var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.763 13.9392L13.4194 15.6203C11.3377 14.3962 9.60269 12.6612 8.37862 10.5795L10.0597 9.23588C10.2567 9.07819 10.3959 8.85971 10.4556 8.61457C10.5152 8.36942 10.492 8.11142 10.3896 7.88084L8.85821 4.43236C8.74843 4.18499 8.55436 3.98465 8.31059 3.86706C8.06683 3.74948 7.78923 3.7223 7.52729 3.79037L4.60914 4.55163C4.33628 4.62136 4.09881 4.78948 3.94237 5.02367C3.78593 5.25786 3.72155 5.54161 3.76162 5.82038C4.2741 9.46325 5.95866 12.8402 8.56061 15.4408C11.1626 18.0414 14.5404 19.7242 18.1836 20.2347C18.4623 20.2748 18.7461 20.2104 18.9803 20.054C19.2145 19.8975 19.3826 19.6601 19.4523 19.3872L20.2136 16.4691C20.2813 16.2073 20.254 15.93 20.1364 15.6865C20.0189 15.443 19.8187 15.2491 19.5716 15.1394L16.118 13.6105C15.8876 13.508 15.6297 13.4846 15.3845 13.544C15.1394 13.6035 14.9209 13.7424 14.763 13.9392Z",
    stroke: "#081B3A",
    strokeWidth: 1.50056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.3109dc4f94bf83a61c4b6cc5fb33673f.svg";
export { ForwardRef as ReactComponent };